import React from "react";
import { Link } from 'react-router-dom';
import Header from '../common/header/Header';
import SEO from '../common/SEO';

const Circle = () => {
    return (
        <>
            <SEO title="Circle - East Coast Coders LLC" />
            <main className="main-wrapper">
                <Header />

                {/* Centered Content */}
                <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh', padding: '2rem', marginTop: '80px' }}>
                    <div className="text-center" style={{ maxWidth: '800px', width: '100%' }}>

                        {/* Header */}
                        <h1 className="mb-4 fw-bold" style={{ fontSize: '2.5rem', color: 'var(--color-heading)' }}>
                            Circle Design
                        </h1>
                        <p style={{ fontSize: '1.1rem', color: '#555', marginBottom: '1.5rem' }}>
                            Exploring AI-driven design concepts at East Coast Coders.
                        </p>

                        {/* Circle Component from Figma */}
                        <div className="mb-5 d-flex justify-content-center">
                            <div style={{
                                width: '400px',
                                height: '400px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <svg
                                    viewBox="0 0 800 800"
                                    style={{ width: '100%', height: '100%' }}
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <ellipse
                                        cx="400"
                                        cy="350"
                                        rx="275"
                                        ry="275"
                                        fill="#D9D9D9"
                                    />
                                </svg>
                            </div>
                        </div>

                        {/* Back to Home Button */}
                        <div>
                            <Link
                                to="/"
                                className="axil-btn btn-fill-primary"
                                style={{
                                    padding: '15px 30px',
                                    fontSize: '1.1rem',
                                    textDecoration: 'none',
                                    display: 'inline-block'
                                }}
                            >
                                Back to Home
                            </Link>
                        </div>

                    </div>
                </div>

            </main>
        </>
    );
};

export default Circle;
